import { PERMISSIONS } from './../actions/types';

const INTIAL_STATE = {
    permissions: []
}

export default function (state = INTIAL_STATE, action) {
  switch (action.type) {
    case PERMISSIONS:
      // console.log(action)
      return { ...state, permissions: action.data };

  }
  return state;
}